import { Phone, Timer, ShieldCheck, Zap } from "lucide-react";
import { Reveal, MaskedLines, MonoLabel } from "../components/Reveal";
import QuoteForm from "../components/QuoteForm";
import Marquee from "../components/Marquee";
import { PHONE_DISPLAY, PHONE_TEL } from "../data/services";

const assurances = [
  { icon: Timer, text: "Quote back in minutes, not hours" },
  { icon: Zap, text: "Vehicle dispatched within ~2 hours" },
  { icon: ShieldCheck, text: "No account, no registration, no bots" },
];

const QuotePage = () => (
  <main>
    <section data-testid="quote-page-hero" className="bg-navy-deep noise-dark pt-40 pb-20">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-8 relative z-10">
        <MonoLabel light className="mb-6">Freight quote — 24/7</MonoLabel>
        <MaskedLines
          lines={["TELL US WHAT", "NEEDS TO MOVE."]}
          className="font-display font-black uppercase tracking-tighter leading-[0.92] text-white text-[11vw] sm:text-[8vw] lg:text-[6.5rem]"
        />
        <p className="mt-8 max-w-xl text-white/70 text-base sm:text-lg leading-relaxed font-medium">
          Fill in the basics and a live agent calls you back within minutes with
          exact pricing and options. Prefer to talk? We answer around the clock.
        </p>
      </div>
    </section>

    <Marquee
      dark
      items={[
        `call ${PHONE_DISPLAY}`,
        "immediate accurate pricing",
        "no ai · no call centers",
        "pickup within 2 hours",
      ]}
    />

    <section data-testid="quote-page-form-section" className="py-24 bg-white">
      <div className="max-w-[1100px] mx-auto px-5 sm:px-8 grid grid-cols-1 lg:grid-cols-12 gap-12">
        <Reveal className="lg:col-span-4">
          <a href={PHONE_TEL} data-testid="quote-page-call-button" className="group inline-flex items-center gap-4">
            <span className="flex h-16 w-16 items-center justify-center bg-royal text-white group-hover:bg-royal-bright transition-colors duration-200">
              <Phone size={24} />
            </span>
            <span>
              <span className="block font-mono text-[11px] tracking-[0.25em] uppercase text-navy/45">
                Fastest — call now
              </span>
              <span className="block font-mono text-2xl font-bold text-royal">{PHONE_DISPLAY}</span>
              <span className="block font-mono text-xs text-navy/40">Humans answer, day or night</span>
            </span>
          </a>
          <ul className="mt-12 space-y-6">
            {assurances.map((a) => (
              <li key={a.text} className="flex items-center gap-4">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center border border-royal/25 text-royal">
                  <a.icon size={17} />
                </span>
                <span className="text-sm font-semibold text-navy/70">{a.text}</span>
              </li>
            ))}
          </ul>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-8">
          <QuoteForm />
        </Reveal>
      </div>
    </section>
  </main>
);

export default QuotePage;
